import { useMemo } from 'react';
import Select from 'react-select';
import { FormularioParte as FormularioParteType, SelectOption } from './types';
import { FieldRow, FieldRowNomeBotao, Label, Input, AddButton, selectStyles, selectTheme, selectComponents } from './styles';
import { Plus } from 'lucide-react';

const getMenuPortalTarget = () => {
    if (typeof document !== 'undefined') {
        return document.body;
    }
    return null;
};

const QUALIFICACOES = [
    'Adverso',
    'Apelado',
    'Apelante',
    'Autor',
    'Autora',
    'Executado',
    'Exequente',
    'Reclamante',
    'Ré',
    'Réu',
    'Requerente',
    'Requerido',
    'Solicitante'
];

const MAX_NOME = 200;

interface FormularioParteProps {
    formulario: FormularioParteType;
    podeAdicionar: boolean;
    isDisabled: boolean;
    onChange: (formulario: FormularioParteType) => void;
    onAdicionar: () => void;
}

export default function FormularioParte({
    formulario,
    podeAdicionar,
    isDisabled,
    onChange,
    onAdicionar
}: FormularioParteProps) {
    const qualificacoesOptions = useMemo<SelectOption[]>(
        () => QUALIFICACOES.map(q => ({ value: q, label: q })),
        []
    );

    const handleSelectChange = (selected: SelectOption | null) => {
        onChange({ ...formulario, tipo: selected?.value || '' });
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange({ ...formulario, nome: e.target.value });
    };

    return (
        <FieldRow>
            <div>
                <Label>Qualificação:</Label>
                <Select
                    styles={selectStyles}
                    components={selectComponents}
                    theme={selectTheme}
                    placeholder="Tipo"
                    value={qualificacoesOptions.find(option => option.value === formulario.tipo) || null}
                    onChange={handleSelectChange}
                    options={qualificacoesOptions}
                    isDisabled={isDisabled}
                    menuPortalTarget={getMenuPortalTarget()}
                    menuPosition="fixed"
                />
            </div>
            <div>
                <Label>Nome da Parte:</Label>
                <FieldRowNomeBotao>
                    <Input
                        value={formulario.nome}
                        placeholder="Digite o nome"
                        maxLength={MAX_NOME}
                        onChange={handleInputChange}
                        disabled={isDisabled}
                        style={{ flex: 1 }}
                    />
                    <AddButton
                        disabled={!podeAdicionar || isDisabled}
                        title={!podeAdicionar ? 'Preencha as informações da parte para adicioná-la' : ''}
                        onClick={onAdicionar}
                    >
                        <Plus size={14} />
                    </AddButton>
                </FieldRowNomeBotao>
            </div>
        </FieldRow>
    );
}

